import { ApiResponse, getFromServer, postToServer, BASE_URL } from "server";

export interface TeacherDashboardStatsOutput {
  totalCount: number;
  statusCount: {
    in_standby: number;
    in_processing: number;
    resolved: number;
    rejected: number;
  };
  subjectDistribution: {
    [key: string]: number;
  };
}

export interface TeacherAvailability {
  available: boolean;
  reason?: string;
}

// Route : GET /problems/mine/stats
export async function getTeacherDashboardStats(): Promise<
  ApiResponse<TeacherDashboardStatsOutput>
> {
  return await getFromServer<TeacherDashboardStatsOutput>(
    `/problems/mine/stats`,
  );
}

// Route : GET /teachers/availability
export async function getTeacherAvailability(): Promise<
  ApiResponse<TeacherAvailability>
> {
  return await getFromServer<TeacherAvailability>(`/teachers/availability`);
}

// Route : POST /teachers/availability
export async function updateTeacherAvailability(
  availability: TeacherAvailability,
): Promise<ApiResponse<TeacherAvailability>> {
  const input = {
    availability: availability,
  };
  return await postToServer<
    { availability: TeacherAvailability },
    TeacherAvailability
  >(`/teachers/availability/update`, input);
}
